import { useState } from "react";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { AdminTitle } from "@/admin/AdminLayout";
import { CB_STATUSES, Section, download } from "@/admin/hr/common";

const PRESETS = [["all", "Tüm başvurular"], ["silahli", "Yalnızca silahlı adaylar"], ["silahsiz", "Yalnızca silahsız adaylar"], ["new", "Yeni başvurular"], ["callback", "Geri aranacak kişiler (Telefonla Görüşülecek)"], ["missing_docs", "Evrakı eksik olanlar"], ["suitable", "Uygun bulunan adaylar"]];

export default function Exports() {
  const [preset, setPreset] = useState("all");
  const [range, setRange] = useState({ date_from: "", date_to: "" });
  const [cbStatus, setCbStatus] = useState("Geri Aranacak");
  const [busy, setBusy] = useState("");
  const run = async (key, url, name, params) => {
    setBusy(key);
    await download(url, name, { params });
    setBusy("");
  };
  const p = { preset, ...range };
  const icon = (k, I) => (busy === k ? <Loader2 className="h-4 w-4 animate-spin" /> : <I className="h-4 w-4" />);
  return (
    <div className="max-w-3xl space-y-4">
      <AdminTitle title="Excel ve PDF Dışa Aktarma" desc="Raporları yalnızca yetkili yönetici oluşturabilir; her indirme denetim kaydına yazılır." />
      <Section title="1. Kapsam" testid="export-presets">
        <div className="grid gap-2 sm:grid-cols-2">
          {PRESETS.map(([k, l]) => (
            <label key={k} className={`flex cursor-pointer items-center gap-2 rounded-md border p-3 text-sm ${preset === k ? "border-[color:var(--red)] bg-red-50" : "border-zinc-200"}`}>
              <input type="radio" name="preset" checked={preset === k} onChange={() => setPreset(k)} className="accent-[color:var(--red)]" data-testid={`preset-${k}`} /> {l}
            </label>
          ))}
        </div>
      </Section>
      <Section title="2. Tarih aralığı (isteğe bağlı)" testid="export-range">
        <div className="grid gap-3 sm:grid-cols-2">
          <input type="date" value={range.date_from} onChange={(e) => setRange({ ...range, date_from: e.target.value })} className="field-input" data-testid="export-date-from" />
          <input type="date" value={range.date_to} onChange={(e) => setRange({ ...range, date_to: e.target.value })} className="field-input" data-testid="export-date-to" />
        </div>
      </Section>
      <Section title="3. İndir" testid="export-actions">
        <div className="flex flex-wrap gap-2">
          <button onClick={() => run("x", "/admin/hr/export/applications.xlsx", "basvurular.xlsx", p)} className="btn-red" data-testid="export-xlsx-btn">{icon("x", FileSpreadsheet)} Excel (.xlsx)</button>
          <button onClick={() => run("p", "/admin/hr/export/applications.pdf", "basvuru-raporu.pdf", p)} className="btn-outline" data-testid="export-pdf-btn">{icon("p", FileText)} PDF Raporu</button>
        </div>
        <p className="mt-3 text-xs text-zinc-500">PDF raporu kurumsal başlık, rapor tarihi, toplam başvuru sayısı ve filtrelenmiş listeyi içerir; e-posta, kart numarası ve doğum tarihi gibi gereksiz kişisel veriler PDF'e eklenmez. Seçili başvuruların belgelerini ZIP olarak indirmek için İş Başvuruları sayfasında kayıtları seçin.</p>
      </Section>
      <Section title="Geri arama kayıtları (Excel)" testid="export-callbacks">
        <div className="flex flex-col gap-2 sm:flex-row">
          <select value={cbStatus} onChange={(e) => setCbStatus(e.target.value)} className="field-input sm:w-64" data-testid="export-cb-status"><option value="">Tüm kayıtlar</option>{CB_STATUSES.map((s) => <option key={s}>{s}</option>)}</select>
          <button onClick={() => run("c", "/admin/hr/export/callbacks.xlsx", "geri-arama.xlsx", { status: cbStatus, ...range })} className="btn-outline" data-testid="export-cb-btn">{icon("c", FileSpreadsheet)} Excel</button>
        </div>
      </Section>
    </div>
  );
}
